import script from "./FramerGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./FramerGallery.vue?vue&type=script&setup=true&lang=js"

import "./FramerGallery.vue?vue&type=style&index=0&id=786d3476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786d3476"]])

export default __exports__